import { IconLayerGray, IconLayers, IconPcLine, IconSecurity } from '@assets/images/icon';
import { IconComputer, IconGuarantee } from '@assets/images/main';
import { IconOsEdgeOff, IconOsEdgeOn, IconOsServerOff, IconOsServerOn, IconOsSwitchOff, IconOsSwitchOn } from '@assets/images/main/icon';
import {
  IconBlueCircle,
  IconBlueCycle,
  IconBlueDevelop,
  IconBlueFigure,
  IconBluePlus,
  IconBluePower,
  IconBlueScan,
  IconBlueShield,
} from '@assets/images/main/icon/blue';
import { osBanner, osDownloadD, osDownloadM, osDownloadT, osLogoDesktop, osLogoMobile, osLogoTablet } from '@assets/images/main/os/bannerImg';
import {
  OsSectionDesktop1,
  OsSectionTablet1,
  OsSectionMobile1,
  OsSectionDesktop2,
  OsSectionTablet2,
  OsSectionMobile2,
  OsSectionDesktop3,
  OsSectionTablet3,
  OsSectionMobile3,
  OsSectionDesktop4,
  OsSectionTablet4,
  OsSectionMobile4,
  OsSectionDesktop5,
  OsSectionTablet5,
  OsSectionMobile5,
  OsSectionDesktop6,
  OsSectionTablet6,
  OsSectionMobile6,
  OsSectionDesktop7,
  OsSectionTablet7,
  OsSectionMobile7,
  OsSectionDesktop8,
  OsSectionTablet8,
  OsSectionMobile8,
  OsSectionDesktop9,
  OsSectionTablet9,
  OsSectionMobile9,
  OsSectionDesktop10,
  OsSectionTablet10,
  OsSectionMobile10,
  OsSectionDesktop11,
  OsSectionTablet11,
  OsSectionMobile11,
  OsSectionDesktop12,
  OsSectionTablet12,
  OsSectionMobile12,
  OsSectionDesktop13,
  OsSectionTablet13,
  OsSectionMobile13,
  OsSectionDesktop14,
  OsSectionTablet14,
  OsSectionMobile14,
  OsSectionDesktop15,
  OsSectionTablet15,
  OsSectionMobile15,
  OsTextImg1,
  OsTextImg2,
  OsTextImg3,
  OsTextImg4,
  OsSectionDesktop16,
  OsSectionTablet16,
  OsSectionMobile16,
  OsSectionDesktop17,
  OsSectionTablet17,
  OsSectionMobile17,
  OsSectionDesktop18,
  OsSectionTablet18,
  OsSectionMobile18,
  OsSectionDesktop19,
  OsSectionTablet19,
  OsSectionMobile19,
  OsSectionDesktop20,
  OsSectionTablet20,
  OsSectionMobile20,
} from '@assets/images/main/os/section';

export default {
  bannerData: [
    {
      icon: IconOsServerOn,
      iconInv: IconOsServerOff,
      image: '',
      iconText: 'ORBROサーバー',
      sub: 'New',
      link: '/jp/os/server',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge RTLS',
      sub: 'New',
      link: '/jp/os/rtls',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/jp/os/ai',
    },
    {
      icon: IconOsSwitchOn,
      iconInv: IconOsSwitchOff,
      image: '',
      iconText: 'L2スイッチ',
      sub: 'New',
      link: '/jp/os/switch',
    },
  ],

  title: '複数のスペースと多様なデバイス、<br/>ひと目でつながるデジタルプラットフォーム',
  desc: 'ORBROサーバーに標準搭載されたORBRO OSで、空間・デバイス・ユーザーを<br/>一画面で管理。どこからでもリアルタイムで情報を確認し、安全な運用を支援します。',

  osLogo: {
    desktop: osLogoDesktop,
    tablet: osLogoTablet,
    mobile: osLogoMobile,
  },

  bannerImg: osBanner,

  section: {
    title: 'ORBRO OSは<br/>ORBROサーバーとORBRO Edgeのみで動作します。',
    desc: '現場の規模や状況に応じて、<br/>小規模環境ではORBRO Edge、大規模ではORBROサーバーで、空間・デバイス・ユーザーを一画面で一元管理できます。',
    tag: [
      {
        icon: IconPcLine,
        title: '24時間安全運用',
        desc: '位置追跡やAI分析などのタスクを途切れることなく実行できる堅牢なハードウェア設計。',
      },
      {
        icon: IconSecurity,
        title: '外部クラウドなしで安全',
        desc: 'データを外部クラウドに送らず、社内ネットワーク・セキュアネットワーク内で処理し、機密情報を保護します。',
      },
      {
        icon: IconLayers,
        title: '無制限の機器・センサー接続',
        desc: '無線タグ、センサー、カメラなど多様なデバイスを追加しても、安定的に運用可能です。',
      },
    ],
    img: {
      desktop: OsSectionDesktop1,
      tablet: OsSectionTablet1,
      mobile: OsSectionMobile1,
    },
  },

  section1: {
    img: OsTextImg1,
    tag: 'リアルタイムモニタリング',
    title: '位置・映像・センサーを<br/>リアルタイムで一目で確認',
    desc: 'IP/PTZカメラ、温湿度・空気質・火災検知センサーを統合的に確認。<br/>異常が検出されると即時にプッシュ通知で対応を支援します。',
    box: [
      {
        size: 1,
        title: 'イベント通知 & リアルタイム位置追跡モニタリング',
        desc: '建物内のエリアへの出入り・イベントをリアルタイムで把握し、RTLSで作業者や訪問者の位置を直感的に表示。特定条件により即時通知され、セキュリティや業務対応を強化できます。',
        img: {
          desktop: OsSectionDesktop2,
          tablet: OsSectionTablet2,
          mobile: OsSectionMobile2,
        },
      },
      {
        size: 2,
        title: 'ライブカメラモニタリング',
        desc: '登録されたカメラのリアルタイム映像を確認し、状態・接続・稼働時間を一目で把握。障害発生時も即対応でき、ORBRO AI機能により位置追跡や物体検出などの高度な分析が可能です。',
        img: {
          desktop: OsSectionDesktop3,
          tablet: OsSectionTablet3,
          mobile: OsSectionMobile3,
        },
      },
      {
        size: 2,
        title: 'ライブセンサーモニタリング',
        desc: '空気質センサーが環境データ（温度・湿度・PM値）をリアルタイムで収集・分析。グラフやダッシュボードで環境変化を直感的に把握し、デバイスの状態・設置場所も統合管理できます。',
        img: {
          desktop: OsSectionDesktop4,
          tablet: OsSectionTablet4,
          mobile: OsSectionMobile4,
        },
      },
    ],
  },

  section2: {
    img: OsTextImg2,
    tag: '空間管理',
    title: '空間をデジタル化し、<br/>仮想と現実の境界をなくす',
    desc: '建物・フロア情報を登録し、機器の位置を指定することで、現実空間をそのままデジタルツインとして再現。<br/>さらに3D図面をアップロードすることで、より精密な環境を構築できます。',
    box: [
      {
        size: 2,
        title: '空間管理',
        desc: '簡単な操作でフロアマップをアップロードし、スケールを入力して実空間と同じサイズのデジタルマップを作成・管理可能。エリアの正確な位置を把握し、カメラ・センサーの配置も直感的に行えます。',
        img: {
          desktop: OsSectionDesktop5,
          tablet: OsSectionTablet5,
          mobile: OsSectionMobile5,
        },
      },
      {
        size: 2,
        title: 'ゾーン管理',
        desc: '図面上にエリアを直接指定し、追跡対象（人物・機器・車両など）を設定して、データを効率的に蓄積・管理。出入りやイベント状況も一目で把握し、空間の運用・安全管理に活用できます。',
        img: {
          desktop: OsSectionDesktop6,
          tablet: OsSectionTablet6,
          mobile: OsSectionMobile6,
        },
      },
      {
        size: 1,
        title: '3D高精度マップ',
        desc: 'より豊富な空間情報を提供するため、3Dファイルをアップロードし、建物の構造やレイアウトをより正確に把握。階高や設備の配置などを視覚的に確認し、空間の活用と安全性向上に役立ちます。',
        img: {
          desktop: OsSectionDesktop7,
          tablet: OsSectionTablet7,
          mobile: OsSectionMobile7,
        },
      },
    ],
  },
  section3: {
    img: OsTextImg3,
    tag: 'アプリ機能',
    title: '記録し、分析し、<br/>自動で対応するスマート運用',
    desc: '移動経路を録画・再生し、Heatmapで行動パターンを可視化、<br/>SOPによって緊急状況を自動処理します。',
    box: [
      {
        size: 1,
        title: 'Heatmap（ヒートマップ）',
        desc: '保存された位置データをもとに、一定期間の人流や訪問パターンを視覚化。日時を選択するだけで、注目エリアや混雑状況が一目で分かり、空間活用やマーケティング戦略に役立ちます。',
        img: {
          desktop: OsSectionDesktop8,
          tablet: OsSectionTablet8,
          mobile: OsSectionMobile8,
        },
      },
      {
        size: 1,
        title: '記録（レコード）',
        desc: '位置データを録画し、特定の時間における移動経路を再生可能。セキュリティ対策や動線の最適化、施設運用効率の向上に活用できます。',
        img: {
          desktop: OsSectionDesktop9,
          tablet: OsSectionTablet9,
          mobile: OsSectionMobile9,
        },
      },
      {
        size: 2,
        title: 'SOPシナリオ設定',
        desc: 'アラームやイベント発生時の標準対応手順（SOP）を自由に構成し、段階ごとのアクションを自動化。条件、対応ステップ、担当者、SMS通知などを設定し、迅速かつ一貫性ある対応が可能になります。',
        img: {
          desktop: OsSectionDesktop10,
          tablet: OsSectionTablet10,
          mobile: OsSectionMobile10,
        },
      },
      {
        size: 2,
        title: 'SOP発動',
        desc: 'SOPが起動すると、発生場所・時間・条件とともに段階別の対応内容が表示され、SMSなどで担当者と即時共有が可能です。',
        img: {
          desktop: OsSectionDesktop11,
          tablet: OsSectionTablet11,
          mobile: OsSectionMobile11,
        },
      },
    ],
  },

  section4: {
    img: OsTextImg4,
    tag: '管理者設定',
    title: 'ユーザー・グループ・デバイスを<br/>一元管理',
    desc: '管理者/ユーザーアカウント、通知グループ、カメラ・センサーなど、<br/>すべての機器を直感的に追加・編集・削除できます。',
    box: [
      {
        size: 2,
        title: 'ユーザー管理',
        desc: 'ユーザーごとのアカウント種別、権限範囲、連絡先情報を簡単に設定・維持できます。',
        img: {
          desktop: OsSectionDesktop12,
          tablet: OsSectionTablet12,
          mobile: OsSectionMobile12,
        },
      },
      {
        size: 2,
        title: 'グループ管理',
        desc: 'ユーザーを部門やチームごとに分類・グルーピングし、効率的に運用できます。',
        img: {
          desktop: OsSectionDesktop13,
          tablet: OsSectionTablet13,
          mobile: OsSectionMobile13,
        },
      },
      {
        size: 2,
        title: '条件通知管理',
        desc: '火災検知、異常ガス、侵入など、特定の状況に対するアラート条件とリスクレベルを設定可能。リスクに応じた通知を自動で送り、即時対応を支援します。',
        img: {
          desktop: OsSectionDesktop14,
          tablet: OsSectionTablet14,
          mobile: OsSectionMobile14,
        },
      },
      {
        size: 2,
        title: 'デバイス管理',
        desc: 'カメラ、センサー、タグなど様々なデバイスを一元登録・管理。状態・バッテリー・通信状況などをリアルタイムで確認し、必要な設定変更も即時対応可能です。',
        img: {
          desktop: OsSectionDesktop15,
          tablet: OsSectionTablet15,
          mobile: OsSectionMobile15,
        },
      },
    ],
  },

  section5: {
    img: OsTextImg4,
    tag: '',
    title: '無線・映像・GPS・入退・IIoTを<br/>1つのプラットフォームで統合管理',
    desc: 'ORBRO OSは位置追跡から入退管理、産業用IoTセンサーまで、<br/>すべてを統合的にサポートします。ラインナップをぜひご確認ください。',
    box: [
      {
        size: 1,
        title: '電波位置追跡',
        desc: 'BLE、AoA、UWBなどの無線技術を活用した位置追跡',
        img: {
          desktop: OsSectionDesktop16,
          tablet: OsSectionTablet16,
          mobile: OsSectionMobile16,
        },
        link: 'https://orbro.io/jp/rtls',
      },
      {
        size: 2,
        title: '映像位置追跡',
        desc: 'AI映像分析を活用した対象物のトラッキング',
        img: {
          desktop: OsSectionDesktop17,
          tablet: OsSectionTablet17,
          mobile: OsSectionMobile17,
        },
        link: 'https://orbro.io/jp/camera',
      },
      {
        size: 2,
        title: '屋外位置追跡',
        desc: '車両・ヤードのGPSベース位置追跡',
        img: {
          desktop: OsSectionDesktop18,
          tablet: OsSectionTablet18,
          mobile: OsSectionMobile18,
        },
        link: 'https://orbro.io/jp/outdoor/gps',
      },
      {
        size: 2,
        title: '入退システム',
        desc: '自動ドア、顔認証などの入退管理機能',
        img: {
          desktop: OsSectionDesktop19,
          tablet: OsSectionTablet19,
          mobile: OsSectionMobile19,
        },
        link: 'https://orbro.io/jp/access',
      },
      {
        size: 2,
        title: 'IIoT',
        desc: '空気質・一酸化炭素センサー、LoRAゲートウェイ、ロボットなどとの連携',
        img: {
          desktop: OsSectionDesktop20,
          tablet: OsSectionTablet20,
          mobile: OsSectionMobile20,
        },
        link: 'https://orbro.io/jp/iot/LoRAGateway',
      },
    ],
  },

  downloadSection: {
    title: 'Web・モバイル・タブレットで、<br/>どこでも安全運用',
    desc: 'ORBRO OSはPCブラウザはもちろん、iOS・Androidアプリ、<br/>タブレットでも同じインターフェースを提供します。',
    ios: 'iOSダウンロード',
    aos: 'Androidダウンロード',
    img: {
      desktop: osDownloadD,
      tablet: osDownloadT,
      mobile: osDownloadM,
    },
  },

  function: {
    title: 'その他の機能',
    box: [
      {
        icon: IconBlueScan,
        title: 'リアルタイムデータ分析と可視化',
        desc: 'OSは収集されたデータを分析し、可視化して、ユーザーが収集された情報をリアルタイムに理解し、活用できるようにします。',
      },
      {
        icon: IconBlueShield,
        title: 'セキュリティと個人データ保護',
        desc: '強力なセキュリティ機能を提供して、デジタルツインを保護します。機密情報へのアクセスを制限し、未承認のデータ変更を防止してセキュリティ問題を最小限に抑えます。',
      },
      {
        icon: IconBlueDevelop,
        title: '開発者向け',
        desc: '開発者がデジタルツイン機能を簡単に活用および拡張できるように設計されています。強力なAPIおよび開発ツールを提供し、新しいアプリケーションやサービスを開発できます。',
      },
      {
        icon: IconBlueFigure,
        title: 'AIの統合',
        desc: '人工知能（AI）技術を統合して、デジタルツインをよりスマートに管理および最適化します。AIアルゴリズムを使用してデータを分析し、予測モデルを構築してシステムのパフォーマンスを向上させます。',
      },
      {
        icon: IconBluePower,
        title: '環境モニタリングとスマートエネルギー管理',
        desc: '環境モニタリングセンサーを統合して、エネルギー消費量とリソース利用を最適化します。環境状況をリアルタイムで監視し、必要に応じてシステムを自動調整してエネルギー効率を最大化します。',
      },
      {
        icon: IconBlueCycle,
        title: '自動化とスマート制御',
        desc: '収集された情報に基づいて、デジタルツインを使用して自動化された決定を行います。例えば、特定の条件が満たされると、デバイスを自動制御したり、プロセスを実行したりできます。',
      },
      {
        icon: IconBluePlus,
        title: 'カスタマイズ可能なユーザーインターフェース',
        desc: 'ユーザーが必要に応じてインターフェースをカスタマイズできる機能を提供します。ユーザーは、デジタルツインを監視および制御するためのダッシュボードやアプリケーションを自由に構成できます。',
      },
      {
        icon: IconBlueCircle,
        title: 'エコシステムの拡張性',
        desc: '開発者や企業がエコシステムを拡張するために、アドオンやプラグインを開発できるようにします。これにより、さまざまな産業やアプリケーション領域にカスタマイズされたソリューションを提供できます。',
      },
    ],
  },

  faqTitle: 'FAQ',

  beacon: {
    index: 4,
  },
  rtls: {
    index: 1,
  },
  camera: {
    index: 2,
  },
  access: {
    index: 3,
  },
  sensor: {
    index: 4,
  },
  integration: {
    index: 1,
  },
};
